import React from "react";
import { Alert, Box, Skeleton, Typography } from "@mui/material";
import { getPlayerBioLines } from "../utils/playerBio";

const nicknameFromBio = (bio) => {
  const nickname = String(bio?.nickName || "").trim();
  if (!nickname || nickname.toLowerCase() === "none") return "";
  return nickname;
};

const PlayerBioSummary = ({
  bio,
  sport = "mlb",
  loading = false,
  error = false,
  dense = false,
}) => {
  const columns = dense
    ? "1fr"
    : { xs: "1fr", sm: "1fr 1fr" };

  if (loading) {
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: columns,
          gap: dense ? 0.75 : 1.5,
        }}
      >
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} width={index % 2 ? "55%" : "80%"} />
        ))}
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" variant="outlined">
        Could not load player details.
      </Alert>
    );
  }

  const nickname = nicknameFromBio(bio);
  const lines = getPlayerBioLines(bio, sport);

  return (
    <Box>
      {nickname ? (
        <Typography
          variant={dense ? "body1" : "h6"}
          color="text.secondary"
          sx={{ mb: dense ? 1 : 1.5 }}
        >
          "{nickname}"
        </Typography>
      ) : null}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: columns,
          columnGap: 3,
          rowGap: dense ? 0.75 : 1,
        }}
      >
        {lines.map((line) => (
          <Typography key={line.label} variant={dense ? "body2" : "body1"}>
            <Box
              component="strong"
              sx={{ color: "text.secondary", fontWeight: 600, mr: 0.75 }}
            >
              {line.label}:
            </Box>
            {line.value}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default PlayerBioSummary;
